// Configuration web Firebase par environnement. Ces valeurs sont publiques (elles finissent dans le bundle) :
// la sécurité repose sur les règles Firestore / Storage, pas sur leur confidentialité.
const CONFIGS = {
  production: {
    apiKey: 'AIzaSyCIFXNBPJ6VR-oqBkZ-N7lohs-MPQGu10E',
    authDomain: 'hyprview-app.firebaseapp.com',
    projectId: 'hyprview-app',
    storageBucket: 'hyprview-app.appspot.com',
    messagingSenderId: '683051021346',
    appId: '1:683051021346:web:8ad822372480d406fac67b',
  },
  preprod: {
    apiKey: 'AIzaSyDXdT0SBVE4x9_lkAriLPbNQ_TmsSYFzLE',
    authDomain: 'hyprview-preprod-ff42c.firebaseapp.com',
    projectId: 'hyprview-preprod-ff42c',
    storageBucket: 'hyprview-preprod-ff42c.firebasestorage.app',
    messagingSenderId: '743576008184',
    appId: '1:743576008184:web:d91aea55926d9732fb920d',
  },
  // Émulateurs locaux (npm run emulators) : projet fictif « demo- », aucune donnée réelle.
  emulator: {
    apiKey: 'demo-key',
    authDomain: 'demo-hyprview.firebaseapp.com',
    projectId: 'demo-hyprview',
    storageBucket: 'demo-hyprview.appspot.com',
  },
};

export const EMULATOR_HOSTS = { auth: 'http://127.0.0.1:9099', firestore: ['127.0.0.1', 8080], storage: ['127.0.0.1', 9199] };

// Choix de l'environnement :
// - `npm run dev`            -> preprod (le développement local ne touche jamais la production)
// - `npm run dev:prod`       -> production, explicitement (VITE_FIREBASE_ENV=production)
// - `npm run dev:emulators`  -> émulateurs locaux (VITE_FIREBASE_ENV=emulator)
// - `npm run build:preprod`  -> preprod (vite build --mode preprod)
// - `npm run build`          -> production
export const FIREBASE_ENV = import.meta.env.VITE_FIREBASE_ENV
  || (import.meta.env.MODE === 'production' ? 'production' : 'preprod');

export function firebaseConfig() {
  const config = CONFIGS[FIREBASE_ENV];
  if (!config) {
    throw new Error(
      `Firebase configuration "${FIREBASE_ENV}" missing in src/components/Firebase/config.js. `
      + 'To use production locally, run `npm run dev:prod` explicitly.',
    );
  }
  return config;
}

// Modèle de données utilisé par l'app : la production reste sur l'ancien modèle (v1) jusqu'à la migration de ses
// données ; preprod et émulateurs utilisent le modèle v2 (docs/DATA_MODEL.md).
export const DATA_MODEL = FIREBASE_ENV === 'production' ? 'v1' : 'v2';
